import { FC } from "react";
import classNames from "classnames";
import { useSetAtom } from "jotai";

import { Button, EButtonVariant } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { DialogContent } from "components/DialogContent/DialogContent";
import { SemiBoldText } from "components/SemiBoldText/SemiBoldText";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";

import { setModalCloseAtom } from "../../atoms/modalAtom/modalAtom";

import styles from "./styles.module.css";

export type ConfirmationModalProps = {
  title: string;
  onConfirm?: () => void;
  confirmText?: string;
  atomToOpen?: any;
  setAtomClose?: any;
  height?: number;
  width?: number;
};

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  title,
  onConfirm,
  confirmText = "Удалить",
  setAtomClose = setModalCloseAtom,
  height,
  width,
}): JSX.Element => {
  const closeModal = useSetAtom(setAtomClose);

  return (
    <DialogContent
      className={classNames(styles.dialog, "flex items-center flex-col" as any)}
      style={{
        height: height ? `${height}px` : undefined,
        width: width ? `${width}px` : undefined,
      }}
      setAtomClose={setAtomClose}
    >
      <SemiBoldText className="mt-7 mb-6 flex justify-center items-center text-center">
        {title}
      </SemiBoldText>
      <VerticalSpace size={36} />
      <div className="flex flex-row">
        <Button onClick={onConfirm} variant={EButtonVariant.SECONDARY}>
          {confirmText}
        </Button>
        <HorizontalSpace size={5} />
        <Button onClick={closeModal} variant={EButtonVariant.TERTIARY}>
          Нет
        </Button>
      </div>
    </DialogContent>
  );
};
